import axios from 'axios';

const API_BASE_URL = '/api/admin';

export const adminCommentService = {
    // Get all comments (admin)
    getComments: async (params = {}) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/comments`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching comments:', error);
            throw error;
        }
    },

    // Get single comment
    getComment: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/comments/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching comment:', error);
            throw error;
        }
    },

    // Approve comment
    approveComment: async (id) => {
        try {
            const response = await axios.put(`${API_BASE_URL}/comments/${id}/approve`);
            return response.data;
        } catch (error) {
            console.error('Error approving comment:', error);
            throw error;
        }
    },

    // Reject comment
    rejectComment: async (id) => {
        try {
            const response = await axios.put(`${API_BASE_URL}/comments/${id}/reject`);
            return response.data;
        } catch (error) {
            console.error('Error rejecting comment:', error);
            throw error;
        }
    },

    // Delete comment
    deleteComment: async (id) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/comments/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting comment:', error);
            throw error;
        }
    },

    // Bulk approve
    bulkApprove: async (commentIds) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/comments/bulk-approve`, {
                comment_ids: commentIds
            });
            return response.data;
        } catch (error) {
            console.error('Error bulk approving comments:', error);
            throw error;
        }
    },

    // Bulk delete
    bulkDelete: async (commentIds) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/comments/bulk-delete`, {
                comment_ids: commentIds
            });
            return response.data;
        } catch (error) {
            console.error('Error bulk deleting comments:', error);
            throw error;
        }
    },
};
